var React = require('react');

function LinkedSmInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.58184 16H0.264581V5.31771H3.58184V16ZM1.92121 3.86057C0.860602 3.86057 0 2.98171 0 1.92114C0 1.41162 0.202413 0.922974 0.56271 0.56269C0.923007 0.202406 1.41167 0 1.92121 0C2.43075 0 2.91942 0.202406 3.27971 0.56269C3.64001 0.922974 3.84242 1.41162 3.84242 1.92114C3.84242 2.98171 2.98182 3.86057 1.92121 3.86057ZM15.9971 16H12.6873V10.8C12.6873 9.56057 12.6622 7.97143 10.9627 7.97143C9.23804 7.97143 8.97346 9.31771 8.97346 10.7109V16H5.65963V5.31771H8.84089V6.77486H8.88717C9.33005 5.93543 10.4118 5.04971 12.0256 5.04971C15.3828 5.04971 16 7.26057 16 10.132V16H15.9971Z","fill":"current"}));
}

LinkedSmInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LinkedSmInline;

LinkedSmInline.default = LinkedSmInline;
